import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input } from '@angular/core';
import { IModalComponent } from '@lib/modal';
import { IRequisition, IRequisitionParticipant } from '@project/view-models';
import { Subject } from 'rxjs';
import { RequisitionHelpersService } from '@project/services';
import { monitorLogger } from '../../../monitor/monitor-logger';

@Component({
  selector: 'app-call-is-ready-to-begin-overlay',
  templateUrl: './call-is-ready-to-begin-overlay.component.html',
  styleUrls: ['./call-is-ready-to-begin-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallIsReadyToBeginOverlayComponent implements IModalComponent, AfterViewInit {
  @Input() requisition: IRequisition | null = null;

  get participant(): IRequisitionParticipant | null {
    return this.requisitionHelpersService.getRequisitionParticipantForVideoCallConfirmation(this.requisition);
  }

  close$ = new EventEmitter();
  submit$ = new EventEmitter();

  private _joinClicked$ = new Subject();
  public joinClicked$ = this._joinClicked$.asObservable();

  private _declineClicked$ = new Subject();
  public declineClicked$ = this._declineClicked$.asObservable();

  constructor(private requisitionHelpersService: RequisitionHelpersService) {}

  ngAfterViewInit() {
    monitorLogger.screen.trackScreen('CALL_ACCEPT', 'tela_aceitar_chamada_medico');
  }

  onJoinClick() {
    monitorLogger.screen.trackScreen('CALL_ACCEPT', 'clicar_botao_aceitar_consulta');
    this._joinClicked$.next();
  }

  onDeclineClick() {
    monitorLogger.screen.trackScreen('CALL_ACCEPT', 'clicar_botao_recusar_consulta');
    this._declineClicked$.next();
  }

  onDisplayed() {
    monitorLogger.screen.trackScreen('CALL_ACCEPT', 'screen_displayed');
  }
}
